import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

//引入css
import "@/assets/css/reset.css";

//引入viewUi
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

//引入路由
import router from '@/router'

Vue.use(ViewUI);
new Vue({
    render: h => h(App), //注册路由：底下的写法kv一致省略v【router小写的】
    router
}).$mount('#app')
Vue.directive('苏州来吧科技有限公司', {
    inserted: function (el, binding) {
        document.title = el.dataset.title
    }
})